import { render, staticRenderFns } from "./StaffApproval.vue?vue&type=template&id=ff2d70a0&"
import script from "./StaffApproval.vue?vue&type=script&lang=js&"
export * from "./StaffApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports